// Shared phone helpers: sanitize input and format as E.164 when possible.
export function formatAsE164(value?: string) {
  if (!value) return '';
  let v = String(value).trim();

  // Convert leading 00 international prefix to +
  if (v.startsWith('00')) {
    v = `+${v.slice(2)}`;
  }

  // If already starts with +, keep plus and strip non-digits
  if (v.startsWith('+')) {
    const digits = v.slice(1).replace(/\D/g, '');
    if (!digits) return '';
    return `+${digits.slice(0, 15)}`;
  }

  // No plus provided: strip to digits
  const digits = v.replace(/\D/g, '');
  // US 10-digit local -> assume +1
  if (digits.length === 10) return `+1${digits}`;
  // If already within E.164 length limits, prefix +
  if (digits.length > 0 && digits.length <= 15) return `+${digits}`;
  // Fallback: return digits (validation will report problem)
  return digits;
}

export function sanitizePhoneInput(value?: string) {
  if (!value) return '';
  const v = String(value).trim();
  if (v.startsWith('+')) {
    const digits = v.slice(1).replace(/\D/g, '');
    return `+${digits.slice(0, 15)}`;
  }
  if (v.startsWith('00')) {
    const digits = v.replace(/\D/g, '');
    return digits.slice(0, 16);
  }
  return v.replace(/\D/g, '').slice(0, 15);
}
